export default __webpack_public_path__ + "media/images/features/hida/grid-6-fe5254620be26b3b6ace0a60bccbbf84.png";